module.exports = __webpack_public_path__ + "media/get-started/lines_3-fbbfb3f8.svg";